module.exports = __webpack_public_path__ + "img/subordinate_bg2.36287bf3.png";